export const resources = {
  en: {
    translation: {
      searchJob: "Search Jobs",
      cvBuilder: " CV Builder",
      Course: "Course",
      Alert: "Alert",
      Register: "Register",
      Login: "Login",
      FORCANDIDATE: "FOR CANDIDATE",
      FOREMPLOYERS: "FOR EMPLOYERS",
      Industries: "Industries",
      Service: "Service",
      Contactus: "Contact us",
      ManageJob: "Manage Job",
      CreateJob: "Create Job",
      Keyword: "Keyword",
      enterKeyword: "Enter Keyword",
      Findtoday: "Find to day",
      To: "To",
      From: "From",
      Date: "Date",
      Time: "Time",
      Find: "Find",
      Jobsposting: "Jobs posting",
      Expiredjob: "Expired job",
      Jobtitle: "Job title",
      industry: "Industry",
      Level: "Level",
      Expiringdate: "Expiring date",
      Action: "Action",
      Confirmdelete: "Confirm delete",
      Areyousure: "Are you sure?",
      HelpingYourBusinessMoveUp: "Helping Your Business Move Up",
      GetYourJobMatchedWithTheRightCandidate:
        "Get Your Job Matched With The Right Candidate",
      BecomeEmployers: "Become Employers",
      WHATWEOFFER: "WHAT WE OFFER",
      Weprovidevariety:
        "We provide a variety of services which help employers connect with more talents, so they can hire faster",
      PostJob: "Post Job",
      Satisfactionguaranteed: "100% Satisfaction guaranteed",
      Postajobandrecieveapplicationsquickly:
        "Post a job and recieve applications quickly",
      Manageyourapplicationonlineeasily:
        "Manage your application online easily",
      SearchResume: "Search Resume",
      dayunlimitedaccesstoprofessionalsdatabase:
        "30-day unlimited access to professionals database",
      Getresultsthatpreciselymatchpeoplewithyourjobs:
        "Get results that precisely match people with your jobs",
      Proactivelysearchforcandidatesandstarthiringtoday:
        "Proactively search for candidates and start hiring today",
      EmployerBranding: "Employer Branding",
      Morethan7millionjobseekersvisitRankWorksamonth:
        "More than 7 million job seekers visit JobLibrary a month",
      Employendbannerhavebeenoptimizedtoattractthemostqualifiedcandidates:
        "Employer logos and banners have been optimized to attract the most qualified candidates",
      Availableposition: "Available position",
      Orderinuse: "Order In Use",
      Candidatesapply: "Candidates apply",
      Activejobs: " Active jobs",
      Pendingjobs: " Pending jobs",
      Inactivejobs: "In active jobs",
      Experedjobs: "Expered jobs",
      Followers: "Followers",
      ACCOUNTINFORMATION: "ACCOUNT INFORMATION",
      MANAGESEARCHRESUMES: "MANAGE SEARCH RESUMES",
      Thereisnocredit: "There is no credit",
      Thereisnoorder: "There is no order",
      MANAGEJOBPOSTINGS: "MANAGE JOB POSTINGS",
      ACTIVITYLOG: "ACTIVITY LOG",
      CAREERBUILDERVNSCONSULTANT: "CAREERBUILDER.VN'SCONSULTANT",
      Topnewcandidates: "Top 8/10 new candidates",
      Industries: "Industries",
      Jobs: "Jobs",
      JobLibrary: "Job Feed",
      WelcometoCVLibrary: "Welcome to JobLibrary",
      LOGIN: "LOGIN",
      EMPLOYERREGISTRATION: "EMPLOYER  REGISTRATION",
      Password: "Password",
      Enteryourpassword: "Enter your password",
      Enteryouremail: "Enter your email",
      Confirmpassword: "Confirm Password",
      Companyname: "Company name",
      Companyaddress: "Company address",
      Size: "Size",
      City: "City",
      Companysummary: "Company summary",
      Contactname: "Contact name",
      Phone: "Phone",
      REGISTER: "REGISTER",
      Less10: "Less 10",
      Thetwopasswordsthatyouentereddonotmatch:
        "The two passwords that you entered do not match",
      EMPLOYERLOGIN: "EMPLOYER LOGIN",
      LOGININFORMATION: "LOGIN INFORMATION",
      Forgotpassword: "Forgot password",
      Submit: "Submit",
      Over1000Rusumerealwithyou: "Over 1000 Resume real with you",
      LogIn: "LogIn",
      Youdonthaveanaccount: "You don't have an account ?",
      RegisterNow: "Register Now",
      TopCompanies: "Top Companies",
      NewJob: "New Job",
      TheNewJobs: "The New Jobs",
      Intership: "Intership",
      Parttime: "Part-time",
      Choosecvtemplate: "Choose CV template",
      DesignCV: "Design CV",
      Infomation: "Infomation",
      Complete: "Complete",
      Previous: "Previous",
      Next: "Next ",
      Done: "Done",
      CongratulationyouactiveaccountsuccessfullyPlease:
        "Congratulation you active account successfully. Please",
      LoginNow: "Login Now",
      Home: "Home ",
      Company: " Company",
      Found: "Found",
      companiesarerecruiting: "companies are recruiting",
      Alllocations: "All locations",
      FINDJOB: "FIND JOB",
      Keywordstitles: "Keywords, titles....",
      HaNoi: "Ha Noi",
      DaNang: "Da Nang",
      HoChiMinh: "Ho Chi Minh",
      HoiAn: "Hoi An",
      matchingjobs: "matching jobs",
      Expireson: "Expires on: ",
      Exp: "Exp:",
      Location: "Location",
      Salary: "Salary:",
      Million: "Million",
      New: "New",
      NoPost: "No Post",
      whatareyouthinking: ", what are you thinking ?",
      Loadmore: "Load more",
      Suggestionsforyou: "Suggestions for you",
      UnFollow: "UnFollow",
      Follow: "Follow",
      WelcometoourchannelDevATVietNam: "Welcome to our channel DevAT-VietNam",
      Areyousurewanttodeletethispost: "Are you sure want to delete this post ?",
      create: "Create",
      EditPost: "Edit post",
      delete_outline: "Delete outline",
      RemovePost: "Remove Post",
      content_copy: "Content copy",
      CopyLink: "Copy Link",
      Hidecontent: "Hide content",
      Readmore: "Read more",
      likes: "Likes",
      comments: "Comments",
      Seemorecomments: "See more comments...",
      Hidecomments: "Hide comments",
      Addyourcomments: "Add your comments...",
      Hide: "Hide",
      Show: "Show",
      TheCompleteMicrosoftExcelCourse: "The Complete Microsoft Excel Course",
      FINDOUTMORE: "FIND OUT MORE",
      Courses: "Courses",
      StaffTraining: "Staff Training",
      CourseLogin: "Course Login",
      Contact: "Contact",
      items: "items",
      Becomeabetteryouithover500onlinetrainingcourses:
        "Become a better you with over500 online training courses.",
      PopularCourseCategories: "Popular Course Categories",
      FeaturedProviders: "Featured Providers",
      PopularCourses: "Popular Courses",
      PersonalProfessionalDevelopment50CourseBundle:
        "Personal & Professional Development 50 Course Bundle",
      monthsunlimitedaccesstoover50onlinecourses:
        "12 months unlimited access to over 50 online courses",
      CPDApprovedfullyverifiablequalifications:
        "CPD Approved, fully verifiable qualifications",
      Tutorsupport: "Tutor support",
      Flexiblestudylearnfromanyinternetenableddevice:
        "Flexible study - learn from any internet enabled device",
      Start: "Start",
      CourseCategories: "Course Categories",
      ValidateaQualification: "Validate a Qualification",
      Enterstudentcertificatedetailsbelow:
        "Enter student's certificate details below:",
      FirstName: "First Name",
      LastName: "Last Name",
      CertNo: "Cert No.",
      Admin: "Admin",
      Beauty: "Beauty",
      Business: "Business",
      HealthySafety: "Healthy & Safety",
      Food: "Food",
      Dataandmarketing: "Data and marketing",
      Projectmanager: "Project manager",
      Vocational: "Vocational",
      Getjobsstraighttoyouremailinbox: "Get jobs straight to your email inbox",
      Stayuptodatewiththela:
        "Stay up-to-date with the latest jobs matching your criteria. Our alerts are easy to review on all devices, including desktop, mobile and email.",
      Bethefirsttoapply: "Be the first to apply",
      Stayaheadofthecompet:
        "Stay ahead of the competition and be the first to apply to jobs on CV-Library. You can apply in seconds with our powerful 1-Click apply process.",
      Quickeasysetup: "Quick & easy setup",
      Ittakeslessthanoneminuteto:
        "It takes less than one minute to create a Job Alert on CV-Library. You can manage your alerts at any time and ensure you find the right jobs with ease.",
      Createupto20alerts: "Create upto 20 alerts",
      Createmultiplealertto:
        "Create multiple alerts to receive the jobs you want. Keep an eye on different locations, job titles, and industries, so you never miss a job again.",
      Search229710jobs: "Search 229,710 jobs",
      from9800companies: "from 9,800 companies",
      GetJobAlertsstraighttoyourinbox: "Get Job Alerts straight to your inbox",
      CVLibrarypopularJobAlertsservice:
        "CV-Library's popular Job Alerts service allows you to stay up-to-date with the latest jobs matching your criteria. Set up keywords and save your searches to ensure you get the best jobs first, delivered by email or straight to your CV-Library account.",
      AlreadyregisteredViewmyJobAlerts:
        "Already registered? View my Job Alerts",
      CreateJobAlert: "Create Job Alert",
      KeywordsJobT: "Keywords / Job Title",
      WhySetupJobAlerts: "Why Setup Job Alerts ?",
      RegisteryourCV: "Register your CV",
      Befoundby10000employers: "Be found by 10,000+ employers",
      UploadyourCVandstartapplyingnow: "Upload your CV and start applying-now",
      Downloadtheapp: "Download the app",
      Nevermissanopportunity: "Never miss an opportunity",
      Browseandapplytojobsonthego: "Browse and apply to jobs on the go",
      LearnMore: "Learn More",
      BycreatingjobalertwithJobFeed:
        "By creating a job alert with JobFeeds you agree to our Privacy Policy and Terms & Conditions",
      Alreadyhaveanaccount: "Already have an account ?",
      Graspyoursuccesswith: "Grasp your success with",
      careeropportunities: "34.115 career opportunities",
      SEARCHJOB: "SEARCH JOB",
      Uploadyourresumeforquickapply: "Upload your resume for quick apply",
      UPLOADNOW: "UPLOAD NOW",
      JobIndustries: "Job Industries",
      ITSoftware: "IT - Software",
      FinanceInvestment: "Finance - Investment",
      Sales: "Sales",
      Marketing: "Marketing",
      Networking: "Networking",
      Banking: "Banking",
      ElectricalElectronic: "Electrical - Electronic",
      CivilConstruction: "Civil - Construction",
      AdvertisingPR: "Advertising - PR",
      Architeture: "Architeture",
      HumanResource: "Human Resource",
      Auditing: "Auditing",
      CandidatesSayAbout: "Candidates Say About JobLibrary",
      nx1: "I was impressed with the candidate CV sent from JobLibrary. CV presented very clearly, eye-catching, helping me immediately see the strengths of each candidate. Thanks to that, the recruitment process is also more convenient.",
      nx2: "JobLibrary is a very creative and practical idea. I have edited my CV much better from the references on the website.",
      nx3: "I have 10 years of experience in management, but so far my CV still looks unprofessional. JobLibrary has helped me have a much more standard and professional CV.",
      ProfessionalCVupdated: "Professional CV updated",
      Employersoftenfindcandidateson:
        "Employers often find candidates on JobLibrary",
      Candidatefoundsuitablejob: "Candidate found suitable job",
      SowhynotstartyourdreamjobwithJobLibrary:
        "So why not start your dream job with JobLibrary",
      NoPost: "No Post",
      Friends: "Friends",
      Messenger: "Messenger",
      Groups: "Groups",
      Saved: "Saved",
      Whatsonyourmind: "What's on your mind,",
      DeletePost: "Delete Post",
      Search: "Search...",
      Call: "Call",
      HomeAddress: "Home address",
      Experience: "Experience",
      Present: "Present",
      Education: "Education",
      Educationname: "Education name",
      Language: "Language",
      Languagename: "Language name",
      Skills: "Skills",
      Hobbies: "Hobbies",
      ToolSetting: "Tool Setting",
      Morethan80ofEmployerspreferEnglishCVs:
        "More than 80% of Employers prefer English CVs",
      English: "English",
      Tiengviet: "Vietnamese",
      Fontsize: "Fontsize",
      BackgroundColor: "Background Color",
      Birthday: "Birthday",
      Overview: "Overview",
      Country: "Country",
      VietNam: "Viet Nam",
      Other: "Other",
      Provincecity: "Province/city",
      BirthDate: "Birth Date",
      EnterLastname: "Enter Last name",
      EnterEmail: "Enter Email",
      EnterAddress: "Enter Address",
      Browse: "Browse...",
      Maximuminput200: "Maximum input 200",
      WorkExperience: "Work Experience",
      EnterCompany: "Enter Company",
      JobPosition: "Job Position",
      EnterJobposition: "Enter Job position",
      Jobdescription: "Job description",
      Maximuninput100: "Maximun input 100",
      WorkexperienceDescriptions: "Work experience Descriptions",
      Addfield: "Add field",
      EnterEducationname: "Enter Education name",
      Educationdescription: "Education description",
      EnterEducationDescriptions: "Enter Education Descriptions",
      Japan: "Japan",
      China: "China",
      Languagelevel: "Language level",
      Elementary: "Elementary",
      Intermediate: "Intermediate",
      HighLevel: "High-Level",
      NativeLanguage: "Native Language",
      Languagedescription: "Language description",
      EnterLanguageDescriptions: "Enter Language Descriptions",
      ProfessionalSkills: "Professional Skills",
      EnterSkill: "Enter Skill",
      Level: "Level",
      EnterSkillDescriptions: "Enter Skill Descriptions",
      Chooseprofile: "Choose profile",
      HideInformation: "Hide Information",
      ProfileTitle: "Profile Title",
      Information: "Information",
      Title: "Title",
      EnterName: "Enter First name",
      EnterPhone: "Enter Phone",
      cm1: "Congratulations on your successful CV creation! Your profile has been updated in Profile Management Allow Employers to Search This Profile",
      qlhs: "Profile management",
      taicv: "Dowload CV",
      EditAccount: "Edit Account",
      Following: "Following",
      Accountinformation: "Account information",
      Fullname: "Fullname",
      Contactinformation: "Contact information",
      Address: "Address",
      Gender: "Gender",
      AboutMe: "About Me",
      Afewwordsaboutyou: "A few words about you...",
      About: "About",
      Setting: "Setting",
      EditProfile: "Edit Profile",
      ChangePassword: "Change Password",
      CurrentPassword: "Current Password",
      PleaseinputyourCurrentPassword: "Please input your Current Password",
      PleaseinputyourPassword: "Please input your Password !",
      RePassword: "Re-Password",
      PleaseinputyourRePassword: "Please input your Re-Password!",
      SaveChanges: "Save Changes",
      Change: "Change",
      InputFirstName: "Input First Name",
      InputAddress: "Input Address",
      Male: "Male",
      Female: "Female",
      InputLastName: "Input Last Name",
      InputPhoneNumber: "Input Phone Number",
      Introduction: "Introduction",
      InputIntroduction: "Input Introduction",
      Profile: "Profile",
      Filedoesnotexist: "File does not exist.",
      Theimagevideolargestis5mb: "The image/video largest is 5mb",
      Pleaseaddyourphoto: "Please add your photo.",
      CreatePost: "Create Post",
      Post: "Post",
      Story: "Story",
      Close: "Close",
      ProfileCandidate: "Profile Candidate",
      ManageCV: "Manage CV",
      SavedJobs: "Saved Jobs",
      AppliedJobs: "Applied Jobs",
      Logout: "Logout",
      Youhave: "You have ",
      unreadnoticesAreyousureyouwanttodeleteall:
        "unread notices. Are you sure you want to delete all ?",
      Notification: "Notification",
      DeleteAll: "Delete All",
      YouhavenotcreatedanyCVyet: "You have not created any CV yet",
      RESUME: "RESUME",
      Kindofresume: "Kind of resume:",
      Profilecreatedonline: "Profile created online",
      Status: "Status",
      Waiting: "Waiting",
      Datecreate: "Date create:",
      View: "View",
      Allowemployerstosearchyourresumeandcontactyou:
        "Allow employers to search your resume and contact you",
      Update: "Update",
      Ifyoudonothaveaprofilefile: "If you do not have a profile file:",
      Createprofilebyonlinedeclarationform:
        "Create Profile By Online Declaration Form",
      ManageSavedJobs: "Manage Saved Jobs",
      Expired: "Expired :",
      Apply: "Apply",
      ApplyNow: "Apply Now",
      Youareapplyingfor: "You are applying for",

      resumeonJobLibraryPleaseselectaresumetoapplyfor:
        "resume on JobLibrary. Please select a resume to apply for",
      PleasecreateCV: "Please create CV",
      CreateCVonline: "Create CV online",
      UnSave: "UnSave",
      SaveJob: "Save Job",
      ManageAppliedJobs: "Manage Applied Jobs",
      Appliedon: "Applied on",
      Delete: "Delete",
      Popularindustries: "Popular industries",
      Browseindustryjobtitlesandlocations:
        "Browse industry job titles and locations",
      Searchforacourse: "Search for a course",
      ProfileCompany: "Profile Company",
      ManageJob: "Manage Job",
      JobPosting: "Job Posting",
      CreateJob: "Create Job",
      RecruitmentInformation: "Recruitment Information",
      ContactInfomation: "Contact Infomation",
      Jobrequirement: "Job requirement",
      Industry: "Industry",
      Selectone: "Select one",
      Workinglocation: "Working location",
      Min: "Min",
      Max: "Max",
      Employmenttype: "Employment type",
      Expiringdate: "Expiring date",
      Benefit: "Benefit",
      Norequired: "No required",
      ResetForm: "Reset Form",
      Careerlevel: "Career level",
      StudentIntership: "Student / Intership",
      Entrylevel: "Entry level",
      Teamleader: "Team leader",
      Manager: "Manager",
      Contactaddress: "Contact address",
      Contactphone: "Contact phone",
      Contactemail: "Contact email",
      Back: "Back",
    },
  },
  vi: {
    translation: {
      searchJob: "Tìm kiếm việc làm",
      cvBuilder: " Tạo CV",
      Course: "Khóa học",
      Alert: "Thông báo",
      Register: "Đăng kí",
      Login: "Đăng nhập",
      FORCANDIDATE: "Dành cho Ứng viên",
      FOREMPLOYERS: "Dành cho Nhà Tuyển Dụng",
      Industries: "Các ngành nghề",
      Service: "Dịch vụ",
      Contactus: "Liên hệ",
      ManageJob: "Quản lí Đăng Tuyển",
      CreateJob: "Đăng Tuyển Dụng  ",
      Keyword: "Từ Khóa",
      enterKeyword: "Nhập từ khóa",
      Findtoday: "Tìm theo ngày",
      To: "Từ",
      From: "Đến",
      Date: "Ngày",
      Time: "Thời gian",
      Find: "Tìm",
      Jobsposting: "Đăng Tuyển",
      Expiredjob: "Đăng tuyển hết hạn",
      Jobtitle: "Chức vụ",
      industry: "Ngành nghề",
      Level: "Trình độ",
      Expiringdate: "Ngày hết hạn",
      Action: "Thao tác",
      Confirmdelete: "Xác nhận xóa",
      Areyousure: "Bạn chắc chắn?",
      HelpingYourBusinessMoveUp: "Giúp doanh nghiệp của bạn vươn xa",
      GetYourJobMatchedWithTheRightCandidate: "Tìm Đúng Người, Trao Đúng Việc",
      BecomeEmployers: "Trở thành Nhà Tuyển Dụng",
      WHATWEOFFER: "DỊCH VỤ CỦA CHÚNG TÔI",
      Weprovidevariety:
        "Chúng tôi cung cấp nhiều dịch vụ giúp nhà tuyển dụng kết nối với nhiều nhân tài hơn, để họ có thể kết nối với ứng cử viên nhanh hơn",
      PostJob: "Đăng Tuyển Dụng",
      Satisfactionguaranteed: "Đảm bảo hài lòng 100%",
      Postajobandrecieveapplicationsquickly:
        "Đăng tuyển nhanh chóng và nhận hồ sơ ngay lập tức",
      Manageyourapplicationonlineeasily:
        "Quản lý hồ sơ trực tuyến của bạn dễ dàng",
      SearchResume: "Tìm hồ sơ",
      dayunlimitedaccesstoprofessionalsdatabase:
        "30 ngày truy cập không giới hạn hệ thống dữ liệu chuyên nghiệp",
      Getresultsthatpreciselymatchpeoplewithyourjobs:
        "Tìm ứng viên hiệu quả và nhanh chóng",
      Proactivelysearchforcandidatesandstarthiringtoday:
        "Chủ động tìm kiếm ứng viên ngay hôm nay",
      EmployerBranding: "Quảng bá thương hiệu",
      Morethan7millionjobseekersvisitRankWorksamonth:
        "Trang chủ JobLibrary nhận được hơn 7 triệu lượt truy cập mỗi tháng từ các ứng viên và chuyên gia giỏi nhất tại Việt Nam",
      Employendbannerhavebeenoptimizedtoattractthemostqualifiedcandidates:
        "Đặt Logo và Banner tại trang chủ sẽ là vị trí chiến lược để thu hút nhân tài",
      Availableposition: "Vị trí chưa sử dụng",
      Orderinuse: "Đơn hàng đang sử dụng",
      Candidatesapply: "Ứng viên ứng tuyển",
      Activejobs: "Việc làm đang đăng",
      Pendingjobs: "Việc làm chờ đăng",
      Inactivejobs: "Việc làm tạm dừng đăng",
      Experedjobs: "Việc làm hết hạn",
      Followers: "Người theo dõi",
      ACCOUNTINFORMATION: "THÔNG TIN TÀI KHOẢN",
      MANAGESEARCHRESUMES: "TÌM KIẾM HỒ SƠ",
      Thereisnocredit: "Chưa có điểm xem hồ sơ",
      Thereisnoorder: "Chưa có dịch vụ xem hồ sơ",
      MANAGEJOBPOSTINGS: "QUẢN LÍ ĐĂNG TUYỂN",
      ACTIVITYLOG: "LỊCH SỬ HOẠT ĐỘNG",
      CAREERBUILDERVNSCONSULTANT: "THÔNG TIN NHÂN VIÊN TƯ VẤN",
      Topnewcandidates: "Top 8 / 10 hồ sơ mới ",
      Industries: "Ngành nghề",
      Jobs: "Công việc",
      JobLibrary: "Job Feed",
      WelcometoCVLibrary: "Chào mừng đến với JobLibrary",
      LOGIN: "ĐĂNG NHẬP",
      EMPLOYERREGISTRATION: "NHÀ TUYỂN DỤNG ĐĂNG KÍ",
      Password: "Mật khẩu",
      Enteryourpassword: "Nhập Mật Khẩu",
      Enteryouremail: "Nhập Email",
      Confirmpassword: "Xác nhận mật khẩu",
      Companyname: "Tên Công ty",
      Companyaddress: "Địa chỉ Công ty",
      Size: "Phạm vi",
      City: "Thành phố",
      Companysummary: "Tóm tắt về công ty",
      Contactname: "Tên người liên hệ",
      Phone: "Số điện thoại",
      REGISTER: "ĐĂNG KÍ",
      Less10: "Ít hơn 10",
      Thetwopasswordsthatyouentereddonotmatch:
        "Hai mật khẩu bạn đã nhập không khớp",
      EMPLOYERLOGIN: "NHÀ TUYỂN DỤNG ĐĂNG NHẬP",
      LOGININFORMATION: "THÔNG TIN ĐĂNG NHẬP",
      Forgotpassword: "Quên mật khẩu",
      Submit: "Gửi",
      Over1000Rusumerealwithyou: "Hơn 1000 hồ sơ với người dùng thực sự ",
      LogIn: "Đăng nhập",
      Youdonthaveanaccount: "Bạn chưa có tài khoản ?",
      RegisterNow: "Đăng kí ngay",
      TopCompanies: "Các Công ty hàng đầu",
      NewJob: "Việc làm mới",
      TheNewJobs: "Việc làm mới",
      Intership: "Thực tập",
      Parttime: "Bán thời gian",
      Choosecvtemplate: "Chọn mẫu CV",
      DesignCV: "Thiết kế CV ",
      Infomation: "Thông tin",
      Complete: "Hoàn thành",
      Previous: "Trước",
      Next: "Tiếp",
      Done: "Đã xong",
      CongratulationyouactiveaccountsuccessfullyPlease:
        "Chúc mừng bạn đã kích hoạt email thành công. Hãy",
      LoginNow: "Đăng nhập ngay",
      Home: "Trang chủ ",
      Company: " Công ty",
      Found: "Tìm thấy",
      companiesarerecruiting: "công ty đang tuyển dụng ",
      Alllocations: "Tất cả vị trí",
      FINDJOB: "Tìm Việc",
      Keywordstitles: "Từ khóa, tiêu đề ,....",
      HaNoi: "Hà Nội ",
      DaNang: "Đà Nẵng ",
      HoChiMinh: "Hồ Chí Minh ",
      HoiAn: "Hội An",
      Jobs: " Công việc ",
      matchingjobs: "công việc phù hợp",
      Expireson: "Hết hạn vào: ",
      Exp: "Kinh nghiệm:",
      Location: "Địa điểm :",
      Salary: "Lương: ",
      Million: "Triệu",
      New: "Mới ",
      NoPost: "Không có bài đăng",
      whatareyouthinking: ", bạn đang nghĩ gì vậy ?",
      Loadmore: "Tải thêm",
      Suggestionsforyou: "Gợi ý dành cho bạn",
      UnFollow: "Bỏ theo dõi",
      Follow: "Theo dõi",
      WelcometoourchannelDevATVietNam:
        "Chào mừng đến với kênh DevAT-ViệtNam của chúng tôi",
      Areyousurewanttodeletethispost: "Bạn chắc chắn muốn xóa bài đăng này ?",
      create: "Tạo",
      EditPost: "Chỉnh sửa bài đăng",
      delete_outline: "Xóa phác thảo",
      RemovePost: "Xóa bài đăng",
      content_copy: "Sao chép nội dung",
      CopyLink: "Sao chép đường dẫn",
      Hidecontent: "Ẩn nội dung",
      Readmore: "Đọc thêm",
      likes: "Lượt thích",
      comments: "Bình luận",
      Seemorecomments: "Xem thêm các bình luận...",
      Hidecomments: "Ẩn bình luận",
      Addyourcomments: "Thêm bình luận của bạn",
      Post: "Đăng",
      Hide: "Ẩn",
      Show: "Hiện",
      TheCompleteMicrosoftExcelCourse: "Toàn bộ khóa học Microsoft Excel",
      FINDOUTMORE: "TÌM HIỂU THÊM",
      Courses: "Các khóa học",
      StaffTraining: "Đào tạo nhân viên",
      CourseLogin: "Đăng nhập khóa học",
      Contact: "Liên hệ",
      items: "mặt hàng",
      Becomeabetteryouithover500onlinetrainingcourses:
        "Trở nên tốt hơn với hơn 500 khóa đào tạo trực tuyến",
      PopularCourseCategories: "Danh mục khóa học phổ biến",
      FeaturedProviders: "Nhà cung cấp nổi bật",
      PopularCourses: "Các khóa học phổ biến",
      PersonalProfessionalDevelopment50CourseBundle:
        "Gói 50 Khóa học Phát triển Cá nhân & Chuyên nghiệp",
      monthsunlimitedaccesstoover50onlinecourses:
        "12 tháng truy cập không giới hạn vào hơn 50 khóa học trực tuyến",
      CPDApprovedfullyverifiablequalifications:
        "Chứng chỉ CPD được phê duyệt, hoàn toàn có thể xác minh được",
      Tutorsupport: "Hổ trợ gia sư",
      Flexiblestudylearnfromanyinternetenableddevice:
        "Học tập linh hoạt - học từ bất kỳ thiết bị hỗ trợ internet nào",
      Start: "Bắt đầu",
      CourseCategories: "Danh mục khóa học",
      ValidateaQualification: "Đánh giá trình độ chuyên môn",
      Enterstudentcertificatedetailsbelow:
        "Nhập chi tiết chứng chỉ của sinh viên dưới đây:",
      FirstName: "Tên",
      LastName: "Họ",
      CertNo: "Số chứng chỉ",
      Admin: "Quản trị viên",
      Beauty: "Sắc đẹp",
      Business: "Kinh doanh",
      HealthySafety: "Sức khỏe & An toàn",
      Food: "Thực phẩm",
      Dataandmarketing: "Dữ liệu và Tiếp thị",
      Projectmanager: "Quản lí dự án",
      Vocational: "Dạy nghề",
      Getjobsstraighttoyouremailinbox:
        "Nhận công việc trực tiếp vào hộp thư email của bạn",
      Stayuptodatewiththela:
        "Luôn cập nhật những công việc mới nhất phù hợp với tiêu chí của bạn. Cảnh báo của chúng tôi dễ dàng xem xét trên tất cả các thiết bị, bao gồm cả máy tính để bàn, điện thoại di động và email.",
      Bethefirsttoapply: "Hãy là người đầu tiên áp dụng",
      Stayaheadofthecompet:
        "Luôn dẫn đầu đối thủ và là người đầu tiên nộp đơn xin việc trên CV-Library. Bạn có thể đăng ký trong vài giây với quy trình đăng ký 1 lần nhấp mạnh mẽ của chúng tôi.",
      Quickeasysetup: "Thiết lập nhanh chóng và dễ dàng",
      Ittakeslessthanoneminuteto:
        "Chỉ mất chưa đầy một phút để tạo Thông báo tuyển dụng trên CV-Library. Bạn có thể quản lý các cảnh báo của mình bất cứ lúc nào và đảm bảo bạn dễ dàng tìm được công việc phù hợp.",
      Createupto20alerts: "Tạo tối đa 20 cảnh báo",
      Createmultiplealertto:
        "Tạo nhiều cảnh báo để nhận các công việc bạn muốn. Theo dõi các vị trí, chức danh công việc và ngành nghề khác nhau để bạn không bao giờ bỏ lỡ một công việc nào nữa.",
      Search229710jobs: "Tìm kiếm 229,710 công việc",
      from9800companies: "từ 9,800 công ty",
      GetJobAlertsstraighttoyourinbox:
        "Nhận thông báo việc làm trực tiếp đến hộp thư đến của bạn",
      CVLibrarypopularJobAlertsservice:
        "Dịch vụ Thông báo việc làm phổ biến của CV-Library cho phép bạn cập nhật những công việc mới nhất phù hợp với tiêu chí của bạn. Thiết lập các từ khóa và lưu các tìm kiếm của bạn để đảm bảo bạn nhận được công việc tốt nhất trước tiên, được gửi qua email hoặc chuyển thẳng đến tài khoản CV-Library của bạn.",
      AlreadyregisteredViewmyJobAlerts:
        "Đã đăng ký? Xem thông báo việc làm của tôi",
      CreateJobAlert: "Tạo thông báo việc làm",
      KeywordsJobT: "Từ khóa / Chức vụ ",
      WhySetupJobAlerts: "Tại sao phải thiết lập thông báo việc làm ?",
      RegisteryourCV: "Đăng ký CV của bạn",
      Befoundby10000employers: "Được 10,000+ nhà tuyển dụng tìm thấy",
      UploadyourCVandstartapplyingnow:
        "Đăng tải CV của bạn và bắt đầu ứng tuyển ngay!",
      Downloadtheapp: "Tải ứng dụng",
      Nevermissanopportunity: "Không bao giờ bỏ lỡ cơ hội",
      Browseandapplytojobsonthego:
        "Duyệt và nộp đơn đơn xin việc ngay khi di chuyển",
      LearnMore: "Tìm hiểu thêm",
      BycreatingjobalertwithJobFeed:
        "Bằng cách tạo thông báo việc làm với JobFeeds, bạn đồng ý với Chính sách quyền riêng tư và Điều khoản & Điều kiện của chúng tôi",
      Alreadyhaveanaccount: "Đã có tài khoản ?",
      Graspyoursuccesswith: "Nmaws bát thành công của bạn với",
      careeropportunities: "34.115 cơ hội nghề nghiệp ",
      SEARCHJOB: "TÌM VIỆC",
      Uploadyourresumeforquickapply:
        "Tải lên sơ yếu lý lịch của bạn để ứng tuyển nhanh chóng",
      UPLOADNOW: "ĐĂNG TẢI NGAY",
      JobIndustries: "Các ngành việc làm",
      ITSoftware: "IT - Phần mềm",
      FinanceInvestment: "Tài chính - đầu tư",
      Sales: "Bán hàng",
      Marketing: "Tiếp thị",
      Networking: "Mạng",
      Banking: "Ngân hàng",
      ElectricalElectronic: "Điện - Điện tử",
      CivilConstruction: "Dân dụng - xấy dựng",
      AdvertisingPR: "Quảng cáo",
      Architeture: "Kiến trúc",
      HumanResource: "Quản lí nhân sự",
      Auditing: "Kiểm toán",
      CandidatesSayAbout: "Các ứng viên nói về JobLibrary",
      nx1: "Tôi có ấn tượng mạnh với CV ứng viên được gửi từ JobLibrary. CV trình bày rất rõ ràng, bắt mắt, giúp tôi thấy ngay được điểm mạnh của từng ứng viên. Nhờ đó mà công tác Tuyển dụng cũng thuận lợi hơn.",
      nx2: "JobLibrary là một ý tưởng rất sáng tạo và thực tế. Tôi đã chỉnh sửa CV của mình tốt lên hơn rất nhiều từ những mẫu tham khảo trên trang web.",
      nx3: "Tôi có kinh nghiệm 10 năm trong việc quản lý, tuy nhiên đến giờ CV nhìn vẫn không chuyên nghiệp. JobLibrary đã giúp tôi có CV chuẩn và chuyên nghiệp hơn rất nhiều.",
      ProfessionalCVupdated: "CV chuyên nghiệp đã được tải lên",
      Employersoftenfindcandidateson:
        "Các nhà tuyển dụng thường tìm thấy các ứng viên trên JobLibrary",
      Candidatefoundsuitablejob: "Ứng viên đã tìm thấy công việc phù hợp",
      SowhynotstartyourdreamjobwithJobLibrary:
        "Vậy tại sao không bắt đâu công việc mơ ước của bạn với JobLibrary",
      NoPost: "Không có bài đăng",
      Friends: "Bạn bè",
      Messenger: "Tin nhắn",
      Groups: "Nhóm",
      Saved: "Đã lưu",
      Whatsonyourmind: "Bạn đang nghĩ gì vậy,",
      DeletePost: "Xóa bài đăng",
      Search: "Tìm...",
      Call: "Số điện thoại",
      HomeAddress: "Điạ chỉ",
      Experience: "Kinh nghiệm",
      Present: "Hiện tại",
      Education: "Tốt nghiệp",
      Educationname: "Tốt nghiệp trường",
      Language: "Ngoại ngữ",
      Languagename: "Tên ngoại ngữ",
      Skills: "Kĩ năng",
      Hobbies: "Sở thích",
      ToolSetting: "Công cụ cài đặt",
      Morethan80ofEmployerspreferEnglishCVs:
        "Hơn 80% nhà tuyển dụng thích CV tiếng Anh",
      English: "Tiếng Anh",
      Tiengviet: "Tiếng Việt",
      Fontsize: "Kích cỡ chữ",
      BackgroundColor: "Màu nền",
      Birthday: "Ngày sinh",
      Overview: "Tổng quát",
      Country: "Quốc gia",
      VietNam: "Việt Nam",
      Other: "Khác",
      Provincecity: "Tỉnh / Thành phố",
      BirthDate: "Ngày sinh",
      EnterLastname: "Nhập Họ",
      EnterEmail: "Nhập email",
      EnterAddress: "Nhập địa chỉ",
      Browse: "Chọn",
      Maximuminput200: "Nhập vào tối đa 200 kí tự",
      WorkExperience: "Kinh nghiệm làm việc",
      EnterCompany: "Nhập tên công ty",
      JobPosition: "Vị trí công việc",
      EnterJobposition: "Nhập vị trí công việc",
      Jobdescription: "Mô tả công việc",
      Maximuninput100: "Nhập vào tối đa 100 kí tự",
      WorkexperienceDescriptions: "Mô tả kinh nghiệm làm việc",
      Addfield: "Thêm",
      EnterEducationname: "Nhập tên trường tốt nghiệp",
      Educationdescription: "Mô tả về quá trình học tập tại trường",
      EnterEducationDescriptions: "Nhập mô tả",
      Japan: "Tiếng Nhật",
      China: "Tiếng Trung",
      Languagelevel: "Trình độ ngoại ngữ",
      Elementary: "Sơ cấp",
      Intermediate: "Trung cấp",
      HighLevel: "Cao cấp",
      NativeLanguage: "Ngôn ngữ bản địa",
      Languagedescription: "Mô tả về ngoại ngữ",
      EnterLanguageDescriptions: "Nhập mô tả",
      ProfessionalSkills: "Kĩ năng chuyên nghiệp",
      EnterSkill: "Nhập kĩ năng",
      Level: "Cấp độ",
      EnterSkillDescriptions: "Nhập mô tả kĩ năng",
      Chooseprofile: "Chọn file",
      HideInformation: "Ẩn thông tin",
      ProfileTitle: "Tiêu đề hồ sơ",
      Information: "Thông tin",
      Title: "Tiêu đề",
      EnterName: "Nhập tên",
      EnterPhone: "Nhập số điện thoại",
      cm1: "Chúc mừng bạn đã tạo CV thành công! Hồ sơ của bạn đã được cập nhật trong mục Quản lý hồ sơ Cho phép Nhà Tuyển Dụng tìm kiếm hồ sơ này",
      qlhs: "Quản Lý Hồ Sơ",
      taicv: "Tải CV",
      EditAccount: "Chỉnh sửa tài khoản",
      Following: "Đang theo dõi",
      Accountinformation: "Thông tin tài khoản",
      Fullname: "Tên đầy đủ",
      Contactinformation: "Thông tin liên hệ",
      Address: "Địa chỉ",
      Gender: "Giới tính",
      AboutMe: "Bản thân tôi",
      Afewwordsaboutyou: "Một vài từ về tôi...",
      About: "Về tôi",
      Setting: "Cài đặt",
      EditProfile: "Chỉnh sửa hồ sơ",
      ChangePassword: "Thay đổi mật khẩu",
      CurrentPassword: "Mật khẩu hiện tại",
      PleaseinputyourCurrentPassword: "Hãy nhập mật khẩu hiện tại của bạn !",
      PleaseinputyourPassword: "Hãy nhập mật khẩu của bạn !",
      SaveChanges: "Lưu thay đổi",
      RePassword: "Nhập lại mật khẩu",
      PleaseinputyourRePassword: "Hãy nhập lại mật khẩu của bạn !",
      Change: "Thay đổi",
      InputFirstName: "Nhập tên",
      InputAddress: "Nhập địa chỉ",
      Male: "Nam",
      Female: "Nữ",
      InputLastName: "Nhập họ",
      InputPhoneNumber: "Nhập số điện thoại",
      Introduction: "Giới thiệu",
      InputIntroduction: "Nhập thông tin giới thiệu",
      Profile: "Hồ sơ",
      Filedoesnotexist: "Tập tin không tồn tại",
      Theimagevideolargestis5mb: "Hình ảnh / video lớn nhất là 5mb",
      Pleaseaddyourphoto: "Hãy thêm ảnh của bạn",
      CreatePost: "Tạo bài đăng",
      Post: "Đăng",
      Story: "Tiểu sử",
      Close: "Đóng",
      ProfileCandidate: "Hồ sơ ứng viên",
      ManageCV: "Quản lí CV",
      SavedJobs: "Công việc đã lưu",
      AppliedJobs: "Công việc đã ứng tuyển",
      Logout: "Đăng xuất",
      Youhave: "Bạn có ",
      unreadnoticesAreyousureyouwanttodeleteall:
        "thông báo chưa đọc. Bạn có chắc chắn muốn xóa tất cả ?",
      Notification: "Thông báo",
      DeleteAll: "Xóa tất cả",
      YouhavenotcreatedanyCVyet: "Bạn chưa tạo bất kỳ CV nào ?",
      RESUME: "HỒ SƠ",
      Kindofresume: "Loại hồ sơ:",
      Profilecreatedonline: "Hồ sơ đã tạo trực tuyến",
      Status: "Tình trạng",
      Waiting: "Đang chờ",
      Datecreate: "Ngày tạo",
      View: "Lượt xem",
      Allowemployerstosearchyourresumeandcontactyou:
        "Cho phép nhà tuyển dụng tìm hồ sơ và liên hệ với bạn",
      Update: "Cập nhật",
      Ifyoudonothaveaprofilefile: "Nếu bạn chưa có hồ sơ:",
      Createprofilebyonlinedeclarationform:
        "Tạo hồ sơ bằng mẫu khai báo trực tuyến",
      ManageSavedJobs: "Quản lí những công việc đã lưu",
      Expired: "Hết hạn :",
      Apply: "Ứng tuyển",
      ApplyNow: "Ứng tuyển ngay",
      Youareapplyingfor: "Bạn đang ứng tuyển cho",
      resumeonJobLibraryPleaseselectaresumetoapplyfor:
        "hồ sơ trên JobLibrary. Hãy chọn một hồ sơ để ứng tuyển cho",
      PleasecreateCV: "Hãy tạo CV",
      CreateCVonline: "Tạo CV trực tuyến",
      UnSave: "Bỏ lưu",
      SaveJob: "Lưu ",
      ManageAppliedJobs: "Quản lí những công việc đã ứng tuyển",
      Appliedon: "Đã ứng tuyển ngày",
      Delete: "Xóa",
      Popularindustries: "Các ngành nghề phổ biến",
      Browseindustryjobtitlesandlocations:
        "Duyệt chức danh và vị trí công việc trong ngành",
      Searchforacourse: "Tìm kiếm khóa học",
      ProfileCompany: "Hồ sơ công ty",
      ManageJob: "Quản lí công việc",
      JobPosting: "Đăng tuyển",
      CreateJob: "Tạo bài đăng tuyển dụng",
      RecruitmentInformation: "Thông tin tuyển dụng",
      ContactInfomation: "Thông tin liên hệ",
      Jobrequirement: "Yêu cầu công việc",
      Industry: "Ngành nghề",
      Selectone: "Chọn một",
      Workinglocation: "Nơi làm việc",
      Min: "Thấp nhất",
      Max: "Cao nhất",
      Employmenttype: "Hình thức",
      Expiringdate: "Hạn ứng tuyển",
      Benefit: "Quyền lợi",
      Norequired: "Không kinh nghiệm",
      ResetForm: "Xóa dữ liệu ",
      Careerlevel: "Cấp bậc",
      StudentIntership: "Sinh viên / Thực tập sinh",
      Entrylevel: "Mới tốt nghiệp",
      Teamleader: "Trưởng nhóm",
      Manager: "Quản lí",
      Contactaddress: "Địa chỉ ",
      Contactphone: "Số điện thoại ",
      Contactemail: "Email ",
      Back: "Quay lại",
    },
  },
};
